<template>
  <div class="container">
    <h1 class="titulo m-y-1-sm m-t-3-md m-b-1-md">Créditos</h1>
    <div class="flex-container">
      <div class="flex-col instituciones">
        <h2 class="lista-titulo">Instituciones y organizaciones</h2>
        <div class="lista-elementos">
          <div
            class="elemento"
            v-for="(institucion, idx) in instituciones"
            :key="`institucion_${idx}`"
          >
            <img
              class="foto a11y-simplificada-block"
              :src="require(`@/assets/img/institucion/${institucion.logo}`)"
              alt=""
            />
            <p class="nombre">{{ institucion.nombre }}</p>
          </div>
        </div>
      </div>

      <div class="flex-col estudios">
        <h2 class="lista-titulo">
          Responsables y colaboradores del proyecto “Levantamiento de suelos y sedimentos.
          Contribución al proyecto prioritario rescate del lago de Texcoco.”
        </h2>
        <div class="lista-elementos">
          <h3 class="lista-subtitulo">Responsables Técnicos</h3>
          <router-link
            v-for="investigadorx in personasEstudio.responsables_tecnicos"
            :key="investigadorx.id"
            class="elemento enlace-investigadorxs"
            :to="{
              path: `/creditos/${investigadorx.id}`,
              props: {
                info_investigador: JSON.stringify(investigadorx),
              },
            }"
          >
            <img
              class="foto foto-redondeada a11y-simplificada-block"
              :src="require(`@/assets/img/investigadores/${investigadorx.foto}`)"
              alt=""
            />
            <div class="info-invest" :to="`/${investigadorx.id}`">
              <p class="nombre">
                {{ investigadorx.nombre }} {{ investigadorx.apellido_paterno }}
                {{ investigadorx.apellido_materno }}
              </p>
              <p class="cargo">{{ investigadorx.cargo }}</p>
              <p class="institucion">{{ investigadorx.institucion }}</p>
            </div>
          </router-link>
          <h3 class="lista-subtitulo">Asesores Técnicos</h3>
          <router-link
            v-for="investigadorx in personasEstudio.asesores_tecnicos"
            :key="investigadorx.id"
            class="elemento enlace-investigadorxs"
            :to="{
              path: `/creditos/${investigadorx.id}`,
              props: {
                info_investigador: JSON.stringify(investigadorx),
              },
            }"
          >
            <img
              class="foto foto-redondeada a11y-simplificada-block"
              :src="require(`@/assets/img/investigadores/${investigadorx.foto}`)"
              alt=""
            />
            <div class="info-invest" :to="`/${investigadorx.id}`">
              <p class="nombre">
                {{ investigadorx.nombre }} {{ investigadorx.apellido_paterno }}
                {{ investigadorx.apellido_materno }}
              </p>
              <p class="cargo">{{ investigadorx.cargo }}</p>
              <p class="institucion">{{ investigadorx.institucion }}</p>
            </div>
          </router-link>
          <h3 class="lista-subtitulo">Jefes de brigada</h3>
          <router-link
            v-for="investigadorx in personasEstudio.jefes_brigada"
            :key="investigadorx.id"
            class="elemento enlace-investigadorxs"
            :to="{
              path: `/creditos/${investigadorx.id}`,
              props: {
                info_investigador: JSON.stringify(investigadorx),
              },
            }"
          >
            <img
              class="foto foto-redondeada a11y-simplificada-block"
              :src="require(`@/assets/img/investigadores/${investigadorx.foto}`)"
              alt=""
            />
            <div class="info-invest" :to="`/${investigadorx.id}`">
              <p class="nombre">
                {{ investigadorx.nombre }} {{ investigadorx.apellido_paterno }}
                {{ investigadorx.apellido_materno }}
              </p>
              <p class="cargo">{{ investigadorx.cargo }}</p>
              <p class="institucion">{{ investigadorx.institucion }}</p>
            </div>
          </router-link>
          <h3 class="lista-subtitulo">Colaboradores de campo</h3>
          <router-link
            v-for="investigadorx in personasEstudio.colaboradores_campo"
            :key="investigadorx.id"
            class="elemento enlace-investigadorxs"
            :to="{
              path: `/creditos/${investigadorx.id}`,
              props: {
                info_investigador: JSON.stringify(investigadorx),
              },
            }"
          >
            <img
              class="foto foto-redondeada a11y-simplificada-block"
              :src="require(`@/assets/img/investigadores/${investigadorx.foto}`)"
              alt=""
            />
            <div class="info-invest" :to="`/${investigadorx.id}`">
              <p class="nombre">
                {{ investigadorx.nombre }} {{ investigadorx.apellido_paterno }}
                {{ investigadorx.apellido_materno }}
              </p>
              <p class="cargo">{{ investigadorx.cargo }}</p>
              <p class="institucion">{{ investigadorx.institucion }}</p>
            </div>
          </router-link>
          <h3 class="lista-subtitulo">Jefe de laboratorio</h3>
          <router-link
            v-for="investigadorx in personasEstudio.jefe_laboradorio"
            :key="investigadorx.id"
            class="elemento enlace-investigadorxs"
            :to="{
              path: `/creditos/${investigadorx.id}`,
              props: {
                info_investigador: JSON.stringify(investigadorx),
              },
            }"
          >
            <img
              class="foto foto-redondeada a11y-simplificada-block"
              :src="require(`@/assets/img/investigadores/${investigadorx.foto}`)"
              alt=""
            />
            <div class="info-invest" :to="`/${investigadorx.id}`">
              <p class="nombre">
                {{ investigadorx.nombre }} {{ investigadorx.apellido_paterno }}
                {{ investigadorx.apellido_materno }}
              </p>
              <p class="cargo">{{ investigadorx.cargo }}</p>
              <p class="institucion">{{ investigadorx.institucion }}</p>
            </div>
          </router-link>
          <h3 class="lista-subtitulo">Técnicos de laboratorio</h3>
          <router-link
            v-for="investigadorx in personasEstudio.tecnicos_laboratorio"
            :key="investigadorx.id"
            class="elemento enlace-investigadorxs"
            :to="{
              path: `/creditos/${investigadorx.id}`,
              props: {
                info_investigador: JSON.stringify(investigadorx),
              },
            }"
          >
            <img
              class="foto foto-redondeada a11y-simplificada-block"
              :src="require(`@/assets/img/investigadores/${investigadorx.foto}`)"
              alt=""
            />
            <div class="info-invest" :to="`/${investigadorx.id}`">
              <p class="nombre">
                {{ investigadorx.nombre }} {{ investigadorx.apellido_paterno }}
                {{ investigadorx.apellido_materno }}
              </p>
              <p class="cargo">{{ investigadorx.cargo }}</p>
              <p class="institucion">{{ investigadorx.institucion }}</p>
            </div>
          </router-link>
          <h3 class="lista-subtitulo">Diseño y captura de información</h3>
          <router-link
            v-for="investigadorx in personasEstudio.disenio"
            :key="investigadorx.id"
            class="elemento enlace-investigadorxs"
            :to="{
              path: `/creditos/${investigadorx.id}`,
              props: {
                info_investigador: JSON.stringify(investigadorx),
              },
            }"
          >
            <img
              class="foto foto-redondeada a11y-simplificada-block"
              :src="require(`@/assets/img/investigadores/${investigadorx.foto}`)"
              alt=""
            />
            <div class="info-invest" :to="`/${investigadorx.id}`">
              <p class="nombre">
                {{ investigadorx.nombre }} {{ investigadorx.apellido_paterno }}
                {{ investigadorx.apellido_materno }}
              </p>
              <p class="cargo">{{ investigadorx.cargo }}</p>
              <p class="institucion">{{ investigadorx.institucion }}</p>
            </div>
          </router-link>
        </div>
      </div>

      <div class="flex-col asesores">
        <h2 class="lista-titulo">
          Asesoras y asesores del Diagnóstico científico y recomendaciones para la restauración
          socioambiental de la región impactada por el proyecto Nuevo Aeropuerto de la Ciudad de
          México
        </h2>
        <div class="lista-elementos">
          <router-link
            v-for="investigadorx in personasDiagnostico"
            :key="investigadorx.id"
            class="elemento enlace-investigadorxs"
            :to="{
              path: `/creditos/${investigadorx.id}`,
              props: {
                info_investigador: JSON.stringify(investigadorx),
              },
            }"
          >
            <img
              class="foto foto-redondeada a11y-simplificada-block"
              :src="require(`@/assets/img/investigadores/${investigadorx.foto}`)"
              alt=""
            />
            <div class="info-invest" :to="`/${investigadorx.id}`">
              <p class="nombre">
                {{ investigadorx.apellido_paterno }}
                {{ investigadorx.apellido_materno }}, {{ investigadorx.nombre }}
              </p>
              <p class="cargo">{{ investigadorx.cargo }}</p>
              <p class="institucion">{{ investigadorx.institucion }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Creditos",
  data: () => ({
    investigadorxs: require("@/assets/data/texcoco_creditos_2.json"),
    instituciones: require("@/assets/data/texcoco_creditos_instituciones.json"),
  }),
  mounted() {
    if (document.getElementById("initial-loader")) {
      document.getElementById("initial-loader").remove();
      document.getElementsByTagName("body")[0].style.overflow = "visible";
    }
  },
  computed: {
    personasDiagnostico() {
      return this.investigadorxs.diagnostico;
    },
    personasEstudio() {
      return this.investigadorxs.estudio;
    },
  },
};
</script>

<style lang="scss">
.flex-container {
  display: block;
  margin-bottom: $gap;
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    display: grid;
    grid-template-areas: "inst est" "ase est";
    grid-template-columns: 1fr 1fr;
    gap: $gap * 3;
    margin-bottom: $gap * 3;
  }
}

.instituciones {
  grid-area: inst;
}
.estudios {
  grid-area: est;
}
.asesores {
  grid-area: ase;
}
.flex-col {
  margin-bottom: $gap;
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    margin-bottom: 0;
  }
}
.lista-titulo {
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  font-size: map-get($fuente, "size-alto");
  padding: $gap * 0.5 0;
  margin: 0;
}
.lista-subtitulo {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  font-size: map-get($fuente, "size-secundario");
  margin: $gap 0 0;
  padding: $gap * 0.25 0;
}
.lista-elementos {
  a.enlace-investigadorxs {
    color: #404041;
    &:hover {
      color: #404041;
      background: #e8e8e8;
    }
  }
  .elemento {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding: $gap * 0.25 0;
    margin: 0;
    .foto {
      width: 80px;
      height: 80px;
      object-fit: contain;
      margin-right: 24px;
      &.foto-redondeada {
        border-radius: 50%;
      }
    }
    .nombre {
      font-size: map-get($fuente, "size-primario");
      flex: 1;
      line-height: 1.1em;
    }
    .info-invest {
      flex: 1;
      margin-left: $gap * 0.25;
      .nombre {
        font-size: map-get($fuente, "size-alto");
        line-height: 1.1em;
        margin: 0;
      }
      .cargo {
        font-size: map-get($fuente, "size-secundario");
        line-height: 1.1em;
        margin: 8px 0;
      }
      .institucion {
        font-size: map-get($fuente, "size-secundario");
        line-height: 1.1em;
        margin: 0;
      }
    }
  }
}
</style>
